export function calculateGoal(savingsGoalAmount, yearRequired, amountSavedToDate, growthAmount, currency) {
  const goalcurYear = (new Date).getFullYear();
  const term = (yearRequired - goalcurYear) * 12;

  const i = growthAmount / 100;
  const target = parseInt(savingsGoalAmount);
  const orgSavings = parseInt(amountSavedToDate);
  const goal = target - orgSavings;

  const Savings = orgSavings * (Math.pow((1 + i), ((term / 12))));
  const _savings = Math.round(Savings);

  const j = Math.pow((1 + i), (1 / 12)) - 1;
  const Sum = ((Math.pow((1 + j), term) - 1) / j) * (1 + j);

  let Answer = goal / Sum;
  Answer = Answer.toFixed(0);

  if (Savings > savingsGoalAmount) {
    console.log("Amount saved will grow to more than target amount at the selected growth rate")
  }

  console.log(growthAmount)

  const data = {
    "Target": currency + savingsGoalAmount,
    "Money_Saved_Growth": _savings,
    "Years Remaining": term / 12,
    "Annual Growth Rate": growthAmount + "%",
    "Your monthly saving amount required is":   Answer
  }

  return data;
}
